import { useEventUploadEventPicture } from "@crowdcoursing/api/openapi";

import { useEntityAvatar, type UseEntityAvatarResult } from "./useEntityAvatar";

export const useEventAvatar = (eventId: string | undefined): UseEntityAvatarResult => {
  const { mutateAsync: uploadEventPicture } = useEventUploadEventPicture();

  return useEntityAvatar({
    entityId: eventId,
    entityType: "event",
    pathParamKey: "eventId",
    uploadPicture: uploadEventPicture,
  });
};
